"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getMsGraphResourceName = void 0;

var _environment = require("../environment");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var getMsGraphResourceName = function getMsGraphResourceName() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  var overrideSetting = (0, _overrideSettings.getOverrideSetting)('msGraphResourceName');

  if (overrideSetting) {
    return overrideSetting;
  }

  var env = (0, _environment.determineEnvironment)(location);
  var resourceName;

  switch (env) {
    case _environment.EnvironmentType.PPE:
      resourceName = 'https://graph.microsoft-ppe.com';
      break;

    default:
      resourceName = 'https://graph.microsoft.com';
  }

  return resourceName;
};

exports.getMsGraphResourceName = getMsGraphResourceName;